import { useNavigate } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import ROUTES from '../../route/routes'
import Layout from '../../layouts/common/Layout'

const SessionExpired = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate(ROUTES.ALL.LOGIN);
  };

  return (
    <Layout.CenterWrapper>
      <Typography variant="h2" fontWeight={600} marginY={2}>
        Session Expired
      </Typography>
      <Typography variant="subtitle1" marginBottom={2}>
        Your session has expired. Please log in again to continue.
      </Typography>
      <Button variant="contained" color="primary" onClick={handleLoginRedirect}>
        Go to Login
      </Button>
    </Layout.CenterWrapper>
  );
};

export default SessionExpired;
